import React from "react";

import { cn } from "@/src/lib/utils";

import { PAGE_TITLE_CLASS } from "./dataTableStyles";

import type { LucideIcon } from "lucide-react";
import type { JSX, ReactNode } from "react";

interface DataTableEmptyStateProps {
  title?: string;
  message: string;
  icon: LucideIcon;
  action?: ReactNode;
}

function DataTableEmptyState({
  title,
  message,
  icon: Icon,
  action,
}: DataTableEmptyStateProps): JSX.Element {
  return (
    <div
      className="mb-7 flex flex-col items-center"
      data-testid="DataTableEmptyState"
    >
      {title ? (
        <h2 className={cn(PAGE_TITLE_CLASS, "w-full")}>{title}</h2>
      ) : null}
      <div className="m-10">
        <div className="text-muted-foreground my-5 text-center text-[22px] italic">
          {message}
        </div>
        <div className="flex items-center justify-center">
          <div className="border-border text-border flex size-50 items-center justify-center rounded-full border-6 border-dashed">
            <Icon aria-hidden="true" size={100} />
          </div>
        </div>
        {action ? (
          <div className="mt-7.5 flex items-center justify-center">
            {action}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default DataTableEmptyState;
